import { Card, Flex, Typography, Upload } from 'antd';
import { EditOutlined, UploadOutlined, ExperimentOutlined, FireOutlined } from '@ant-design/icons';
import { ConfigImport } from './ConfigShare';

const { Title, Text, Paragraph } = Typography;

// One option card. `wrap` lets the import option sit inside antd's Upload,
// which has to own the click that opens the file picker.
function Option({ icon, title, text, onClick }) {
    return (
        <Card hoverable className="gathering-start-option" onClick={onClick}>
            <Flex vertical gap={8}>
                <span className="gathering-start-icon">{icon}</span>
                <Text strong style={{ fontSize: 'var(--fs-lg)' }}>{title}</Text>
                <Text type="secondary">{text}</Text>
            </Flex>
        </Card>
    );
}

/**
 * Shown to an admin while the gathering has never been set up
 * (isBlankSetup): design it from scratch, import a setup file from another
 * node, or start from the sample. Import and sample both go through the
 * ConfigImport preview, so nothing changes until the admin confirms.
 */
function StartChooser({ paletteColor, onScratch, onImport, sampleConfig }) {
    return (
        <Card className="gathering-section">
            <Flex vertical align="center" gap={4} style={{ textAlign: 'center', marginBottom: 24 }}>
                <FireOutlined style={{ fontSize: 32, color: 'var(--vellby-sky-500)' }} />
                <Title level={4} style={{ margin: 0 }}>Set up this gathering</Title>
                <Paragraph type="secondary" style={{ maxWidth: 480, margin: 0 }}>
                    A gathering is a flow of common-room time and breakout rounds, with groups people pick,
                    an ideal room, and topics. Start fresh, or reuse a setup.
                </Paragraph>
            </Flex>
            <ConfigImport currentGroups={[]} paletteColor={paletteColor} onImport={onImport}>
                {({ uploadProps, previewConfig }) => (
                    <div className="gathering-start-options">
                        <Option
                            icon={<EditOutlined />}
                            title="Design from scratch"
                            text="Build the flow, groups, ideal room and topics yourself."
                            onClick={onScratch}
                        />
                        <Upload {...uploadProps} className="gathering-start-upload">
                            <Option
                                icon={<UploadOutlined />}
                                title="Import a setup"
                                text="Use a gathering file exported from this or another node."
                            />
                        </Upload>
                        <Option
                            icon={<ExperimentOutlined />}
                            title="Start from the sample"
                            text="Four groups, five topics and a common → two rounds → common flow, ready to edit."
                            onClick={() => previewConfig(sampleConfig, 'The sample gathering')}
                        />
                    </div>
                )}
            </ConfigImport>
        </Card>
    );
}

export default StartChooser;
